<script>
export default {
  props: ['name'],
  emits: ['close-modal'],
  data() {
    return {
      data: {
        id: 0,
        name: '',
        desc: '',
        icon: '',
        slug: '',
        original_icon: '',
      },
      locked: false,
    };
  },
  mounted() {
    if (this.name) {
      this.data.name = this.name;
    }
  },
  methods: {
    createTopic() {
      if (this.locked) return;
      this.locked = true;

      const params = { ...this.data };
      params.icon = this.data.original_icon ? this.data.original_icon : params.icon;

      this.$http
        .post(`${qk_rest_url}createTopic`, params)
        .then(() => {
          this.locked = false;
          this.$message({ message: '成功', type: 'success' });
          this.$emit('close-modal');
        })
        .catch((err) => {
          this.locked = false;
          this.$message({ message: qkGetApiError(err, '上传失败'), type: 'error' });
        });
    },
    imgUploadBox() {
      this.$createModal('imageUploadBox', {
        size: 400,
        props: {
          data: {
            showTabType: 1,
            maxPicked: 1,
            postType: 'circle',
            callback: (data) => {
              this.data.icon = data[0]?.url;
              this.data.original_icon = '';
            },
          },
        },
      });
    },
    destroy() {
      Object.assign(this.$data, this.$options.data.call(this));
    },
  },
};
</script>

<template>
  <div class="create-topic-container">
    <div class="colorful-header qk-flex">
      <div class="title">创建话题</div>
    </div>
    <div class="manage-content-wrap">
      <div class="form-container">
        <div class="base-manage">
          <div class="circle-icon" @click="imgUploadBox">
            <div class="icon-img" style="display: contents">
              <img v-if="data.icon" :src="data.icon" class="w-h" />
              <i v-else class="ri-camera-fill"></i>
            </div>
          </div>
        </div>
        <form @submit.stop.prevent="createTopic">
          <label class="form-item">
            <input
              v-model="data.name"
              type="text"
              autocomplete="off"
              maxlength="30"
              placeholder="话题名称"
              class="input"
            />
            <span class="icon">
              <i class="ri-file-text-line"></i>
            </span>
          </label>
          <label class="form-item">
            <textarea v-model="data.desc" placeholder="话题简介"></textarea>
            <span class="icon">
              <i class="ri-file-text-line"></i>
            </span>
          </label>
          <label class="form-item">
            <input
              v-model="data.slug"
              type="text"
              autocomplete="off"
              maxlength="10"
              placeholder="话题连接"
              class="input"
            />
            <span class="icon">
              <i class="ri-link"></i>
            </span>
            <p class="desc">链接：{{ window.location.origin }}/topic/{{ data.slug }}</p>
          </label>
          <div class="form-button">
            <button type="submit">确认</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
